// extracted by mini-css-extract-plugin
export var dismissOverlay = "_gi-b";
export var interactivePassthrough = "_gi-3";
export var modal = "_gi-d";
export var modalBackdrop = "_gi-c";
export var modalBody = "_gi-j";
export var modalDescription = "_gi-m";
export var modalEnter = "_gi-e";
export var modalFooter = "_gi-n";
export var modalHeaderText = "_gi-h";
export var modalIconCircle = "_gi-i";
export var modalIconHeader = "_gi-g";
export var modalImage = "_gi-f";
export var modalSectionLabel = "_gi-k";
export var modalTitle = "_gi-l";
export var pulse = "_gi-1";
export var pulseBorder = "_gi-2";
export var spotlight = "_gi-0";
export var tooltip = "_gi-4";
export var tooltipButtons = "_gi-9";
export var tooltipDescription = "_gi-6";
export var tooltipFooter = "_gi-7";
export var tooltipInteractivePill = "_gi-a";
export var tooltipStepIndicator = "_gi-8";
export var tooltipTitle = "_gi-5";